import { css } from '@emotion/react'

import { borderRadius, fontSize, size } from '@twisto/styles'

export const button = css`
  & a {
    box-sizing: border-box;
    border-radius: ${borderRadius.sm};
    padding: ${size[18]} ${size[40]};
  }

  & span {
    font-size: ${fontSize.sm};
    font-weight: 500;
  }
`

export const iconButton = css`
  & a {
    box-sizing: border-box;
    border-radius: ${borderRadius.md};

    span {
      display: flex;
      align-items: center;
      gap: ${size[12]};
    }
  }
`
